import React, { Component } from "react";
import { Modal, Input, Table } from "antd";

class ModalNewCar extends Component {
  render() {
    const columns = [
      {
        title: "New Car",
        dataIndex: "carName",
        key: "carName",
        render: text => <span style={{ color: "#002558" }}>{text}</span>,
      },
      {
        title: "Otr",
        dataIndex: "otr",
        key: "otr",
        render: text => (
          <span style={{ color: "#287AE5" }}>
            {this.props.formatRupiah(text)}
          </span>
        ),
      },
    ];
    return (
      <Modal
        bodyStyle={{ height: 500 }}
        footer={[null]}
        title={this.props.title}
        visible={this.props.visible}
        onCancel={() => this.props.visibleModal("New Car", false)}
      >
        <Input.Search
          enterButton
          placeholder="Telusuri Mobil"
          style={{ marginBottom: 10 }}
          size="large"
          onChange={v => this.props.searchNewCar(v)}
        />
        <Table
          columns={columns}
          dataSource={this.props.data}
          pagination={false}
          rowKey={v => v.id}
          scroll={{ y: 400 }}
          showHeader={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => this.props.changeNewCar(record.id),
            };
          }}
        />
      </Modal>
    );
  }
}

export default ModalNewCar;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalNewCar.js